import { PartialType, PickType } from '@nestjs/swagger';
import { JobDto } from './job.dto';
import { JobUpdatableInterface } from '../interfaces/job-updatable.interface';

export class JobUpdateDto
  extends PartialType(
    PickType(JobDto, [
      'voided',
      'houseMarked',
      'zip',
      'exteriorOptionsFinished',
      'interiorOptionsFinished',
      'interiorOptionsFinishedJobPhaseId',
      'exteriorOptionsFinishedJobPhaseId',
      'trimOptionsFinished',
      'trimOptionsFinishedJobPhaseId',
      'address1',
      'address2',
      'city',
      'state',
      'geo',
      'geoDistanceTolerance',
    ] as const),
  )
  implements JobUpdatableInterface {}
